import { render, staticRenderFns } from "./StatisticsByStatus.vue?vue&type=template&id=baba3786"
import script from "./StatisticsByStatus.vue?vue&type=script&lang=js"
export * from "./StatisticsByStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports